import type { AutopilotRow } from '../types';
import { money, signedMoney, wholeMoney } from '../utils';
import { AUTOPILOT } from '../fixtures';

export function AutopilotSummary({ rows, onReview, onSeePosted }: { rows: AutopilotRow[]; onReview: (id: string) => void; onSeePosted: () => void }) {
  const waitingTotal = rows.reduce((s, r) => s + r.amount, 0);
  return (
    <main className="po-detail">
      <div className="po-detail-inner">
        <section className="po-card">
          <div className="po-fig">
            <div>
              <div className="po-fig-label">Posted by ELVA today</div>
              <div className="po-fig-val num">{AUTOPILOT.postedToday.count} payments · {money(AUTOPILOT.postedToday.total)}</div>
              <button type="button" className="po-src" style={{ textDecoration: 'underline' }} onClick={onSeePosted}>See them in Posted</button>
            </div>
            <div>
              <div className="po-fig-label">Waiting for you</div>
              <div className="po-fig-val num">{rows.length} · {wholeMoney(waitingTotal)}</div>
              <div className="po-meta">Each with the reason below</div>
            </div>
          </div>
        </section>

        <section className="po-card" aria-labelledby="po-ap-title">
          <h3 className="po-h3" id="po-ap-title" style={{ marginBottom: 10 }}>Why these came back to you</h3>
          <div className="po-tbl-wrap">
            <table className="po-tbl">
              <thead><tr><th>Patient</th><th>Payer</th><th>Why</th><th className="ta-right">Amount</th><th className="ta-right">Open</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td style={{ fontWeight: 600 }}>{r.patient}</td>
                    <td>{r.payer}</td>
                    <td style={{ color: 'var(--fg2)', maxWidth: 420 }}>{r.why}</td>
                    <td className="ta-right num">{signedMoney(r.amount)}</td>
                    <td className="ta-right"><button type="button" className="po-btn po-btn-sm" onClick={() => { onReview(r.id); }}>Review</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <p className="po-meta" style={{ padding: '0 4px' }}>Turning autopilot off: new payments wait for you again. Nothing already posted changes.</p>
      </div>
    </main>
  );
}
